import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import * as artifactActions from '~/artifact/actions';
import DOMPurify from 'dompurify';

type ArtifactViewMainContentFixInfoHowToFixPatchProps = {
  actions: object;
  artifactState: object;
  component: object;
  range: object;
};
class ArtifactViewMainContentFixInfoHowToFixPatch extends React.Component<
  ArtifactViewMainContentFixInfoHowToFixPatchProps,
  {}
> {
  constructor(props, context) {
    super(props, context);
  }
  componentDidMount() {
    let range = this.props.range,
      fixText = range.fixText || '';
    this.props.actions.fetchMarkdownHtml('fixText', fixText);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.artifactState.viewMode !== nextProps.artifactState.viewMode) {
      let range = nextProps.range,
        fixText = range.fixText || '';
      this.props.actions.fetchMarkdownHtml('fixText', fixText);
    }
  }
  render() {
    let store = this.props.artifactState,
      range = this.props.range,
      markdownHtml = store.markdownHtml,
      fixTextHtml = markdownHtml.fixText,
      fixText = (
        <div
          className="markdown--artifact"
          //eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(fixTextHtml) }}
        />
      ),
      fixLinks = range.fixLinks,
      linkElements = [],
      fixLinkHtml = <div />;
    fixLinks = _.filter(fixLinks, fix => fix.link && fix.description);
    fixLinks.forEach(link => {
      linkElements.push(
        <div className="grid pt-">
          <div className="grid__item col-1-1">
            {link.type.toLowerCase()}:{' '}
            <Link href={link.link} className="link--primary" target="_blank">
              {link.description}
            </Link>
          </div>
        </div>
      );
    });
    if (fixLinks.length > 0) {
      fixLinkHtml = (
        <div>
          <div className="grid__item col-1-1 pt">More references:</div>
          <div className="grid__item col-1-1">{linkElements}</div>
        </div>
      );
    }
    return (
      <section className="grid">
        <div className="grid__item col-1-1">{fixText}</div>
        {fixLinkHtml}
      </section>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    routing: state.routing,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentFixInfoHowToFixPatch);
